import Vue from 'vue';

// eslint-disable-next-line consistent-return
const setupWKWebViewJavascriptBridge = (callback) => {
  if (window.WKWebViewJavascriptBridge) {
    // eslint-disable-next-line no-undef
    return callback(WKWebViewJavascriptBridge);
  }

  if (window.WKWVJBCallbacks) {
    return window.WKWVJBCallbacks.push(callback);
  }

  window.WKWVJBCallbacks = [callback];
  window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
};


Vue.prototype.$iosBridge = setupWKWebViewJavascriptBridge;
const iosBridge = setupWKWebViewJavascriptBridge;
export default iosBridge;
